import { Component } from 'react';
import { connect } from 'react-redux';
import { brand_colors } from '../helpers/brand_colors_helper';
import { getRegionalStorageURL } from '../helpers/regional_storage_url_helper';

const pageHeight = 631.25
const pageWidth = 447
class AssessmentDetailObservation extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    renderHeader = () => {
        const { data } = this.props
        {/* HEADER START */ }
        return <div className={'d-flex flex-row align-items-center justify-content-between'} style={{ height: '5%', borderBottom: 'solid 1px #e7e8e8', fontSize: 7, }}>
            <div style={{ color: '#929292' }} className='px-2'>{data.setHeader[0]}</div>
            <div style={{ color: '#929292' }} className='px-2'>{data.setHeader[1]}</div>
            <div style={{ color: '#929292' }} className='px-2'>{data.setHeader[2]}</div>
        </div>
        {/* HEADER END */ }
    }
    renderFooter = () => {
        {/* FOOTER START */ }
        return <div className={'d-flex flex-row align-items-center justify-content-end'} style={{ height: '5%', borderTop: 'solid 1px #e7e8e8', }}>
            <div style={{ color: '#929292' }} className='px-2'>Page 1 of 5</div>
        </div>
        {/* FOOTER END */ }
    }


    render() {
        const { data } = this.props

        const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

        console.log('AssessmentDetailObservation', data)
        const pageStyle = {
            height: pageHeight, width: pageWidth, background: `url(${regionalStorageURL + this.props.authData.centerData.center_uuid + '/assess_settings/' + data.assessSettingsData['assess_setting_background_image']})`, backgroundSize: 'cover', backgroundPosition: 'center', padding: '0 10px 0 10px'
        }

        // PAGE EMPTY
        //    <div style={pageStyle}>
        //         {this.renderHeader()}
        //         <div className={'d-flex flex-column justify-content-between'} style={{ height: '90%' }}>
        //         </div>
        //         {this.renderFooter()}
        //     </div>

        return (<div style={{ fontSize: 8, fontFamily: 'Roboto', backgroundColor: '#fcfcfc' }}>
            {/* PAGE 1 */}
            <div style={pageStyle}>
                {/* HEADER START */}
                {this.renderHeader()}
                {/* HEADER END */}
                <div className={'d-flex flex-column justify-content-between'} style={{ height: '90%' }}>
                    <div style={{ flex: 1, fontSize: 20 }} className={'d-flex flex-column justify-content-center align-items-center'}>
                        {data.pdfTitle}
                    </div>
                    <div style={{ flex: 1 }} className={'d-flex flex-column justify-content-center align-items-center'}>
                        <div style={{ border: 'solid 1px #e0e0e0', borderRadius: 10, padding: 20, backgroundColor: '#fff' }} className={'d-flex flex-column justify-content-between align-items-center'}>
                            <div style={{ width: 80, height: 80, borderRadius: 50 }} className='mb-3'>
                                <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/children/' + data.pdfInfo.child_picture} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 50 }} />
                            </div>
                            <div className='mb-1' style={{ fontSize: 12, fontWeight: 'bold' }}>{data.pdfInfo.toName}</div>
                            <div style={{ fontSize: 12 }}>{data.pdfInfo.toClass}</div>
                        </div>
                    </div>
                    <div style={{ flex: 1 }} className={'d-flex flex-column justify-content-end align-items-center'}>
                        <div className='mb-1'>
                            <img src={data.centerInfo.logo} style={{ height: 60, objectFit: 'contain', }} />
                        </div>
                        <div className='mb-1' style={{ fontSize: 11 }}>{data.centerInfo.center_name}</div>
                    </div>
                </div>
                {/* FOOTER START */}
                {this.renderFooter()}
                {/* FOOTER END */}
            </div>
            {/* PAGE 2 */}
            <div style={pageStyle}>
                {/* HEADER START */}
                {this.renderHeader()}
                {/* HEADER END */}
                <div className={'d-flex flex-column justify-content-between'} style={{ height: '90%' }}>
                    <div style={{ flex: 1, fontSize: 20 }} className={'d-flex flex-column justify-content-center align-items-center'}>
                    </div>
                    <div style={{ flex: 1 }} className={'d-flex flex-column justify-content-center align-items-center'}>
                        <div style={{ border: 'solid 1px #e0e0e0', borderRadius: 10, padding: 20, backgroundColor: '#fff' }} className={'d-flex flex-column justify-content-between align-items-center'} dangerouslySetInnerHTML={{ __html: data.assrepheader_note }} >
                        </div>
                    </div>
                    <div style={{ flex: 1 }} className={'d-flex flex-column justify-content-end align-items-center'}>
                        <div className='mb-1'>
                            <img src={data.centerInfo.logo} style={{ height: 60, objectFit: 'contain', }} />
                        </div>
                        <div className='mb-1' style={{ fontSize: 11 }}>{data.centerInfo.center_name}</div>
                    </div>
                </div>
                {/* FOOTER START */}
                {this.renderFooter()}
                {/* FOOTER END */}
            </div>


            <div style={pageStyle}>
                {/* HEADER START */}
                {this.renderHeader()}
                {/* HEADER END */}
                <div className={'d-flex flex-column justify-content-between'} style={{ height: '90%' }}>
                    <div className={'py-4 text-center px-4'} style={{ fontSize: 20, color: brand_colors[this.props.defaultTheme.theme_id].color2 }}>
                        What I have Explored
                    </div>
                    <div className={'d-flex flex-row justify-content-between flex-wrap'} style={{ flex: 1 }}>
                        <div style={{ width: 213, height: 213, paddingRight: 10 }}>
                            <div style={{ border: 'solid 2px #0fbae7', borderRadius: 10, width: '100%', height: '100%', backgroundColor: '#d0f1fa' }} className={'d-flex flex-row flex-wrap justify-content-center align-items-center p-2'}>{data.Assrep.assrep_comm1}</div>
                        </div>
                        <div style={{ width: 213, height: 213, paddingLeft: 10 }}>
                            <div style={{ border: 'solid 2px #ed3a81', borderRadius: 10, width: '100%', height: '100%', backgroundColor: '#fbd8e6' }} className={'d-flex flex-row flex-wrap justify-content-center align-items-center p-2'}>{data.Assrep.assrep_comm2}</div>
                        </div>
                        <div style={{ width: 213, height: 213, paddingRight: 10 }}>
                            <div style={{ border: 'solid 2px #5bb946', borderRadius: 10, width: '100%', height: '100%', backgroundColor: '#ddf1da' }} className={'d-flex flex-row flex-wrap justify-content-center align-items-center p-2'}>{data.Assrep.assrep_comm3}</div>
                        </div>
                        <div style={{ width: 213, height: 213, paddingLeft: 10 }}>
                            <div style={{ border: 'solid 2px #0a3441', borderRadius: 10, width: '100%', height: '100%', backgroundColor: '#cdd6d9' }} className={'d-flex flex-row flex-wrap justify-content-center align-items-center p-2'}>{data.Assrep.assrep_comm4}</div>
                        </div>
                    </div>
                </div>
                {/* FOOTER START */}
                {this.renderFooter()}
                {/* FOOTER END */}
            </div>

            {data.assesslogData.map((assesslog_v, assesslog_i) => {
                return <div style={pageStyle}>
                    {/* HEADER START */}
                    {this.renderHeader()}
                    {/* HEADER END */}
                    <div className={'d-flex flex-column justify-content-between'} style={{ height: '90%' }}>
                        {assesslog_v.academic_activities &&
                            <div className='d-flex flex-row my-1'>
                                <div>
                                    <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/academic_activities/' + assesslog_v.academic_activities.aa_image} style={{ height: 60, objectFit: 'contain', }} />
                                </div>
                                <div className='d-flex flex-column'>
                                    <div>{assesslog_v.academic_activities.aa_name}</div>
                                    <div>{assesslog_v.academic_activities.aa_desc}</div>
                                </div>
                            </div>
                        }
                        <div className='d-flex flex-row my-1'>
                            <div className='d-flex flex-column'>
                                <div>{assesslog_v.details.assesslog_name}</div>
                            </div>
                        </div>
                        <div className='d-flex flex-row mt-1' style={{ flex: 1 }}>
                            {/* CONTENT */}
                            <div style={{ flex: 1 }} className='pe-1'>
                                {/* OBSERVATION */}
                                {assesslog_v.details.assesslog_obs &&
                                    <div className='mb-2'>
                                        <div style={{ backgroundColor: '#c5e6c4', borderRadius: 5, paddingTop: 3, paddingBottom: 3 }} className='px-1 mb-1'>{'Observation'}</div>
                                        <div className='d-flex flex-row flex-wrap'>{assesslog_v.details.assesslog_obs}</div>
                                    </div>
                                }
                                {/* NEXT STEP */}
                                {assesslog_v.details.assesslog_next &&
                                    <div>
                                        <div style={{ backgroundColor: '#f0d0d0', borderRadius: 5, paddingTop: 3, paddingBottom: 3 }} className='px-1 mb-1'>{'Next Step'}</div>
                                        <div className='d-flex flex-row flex-wrap'>{assesslog_v.details.assesslog_next}</div>
                                    </div>
                                }
                            </div>
                            {/* IMAGES */}
                            <div style={{ width: 106 }}>
                                {assesslog_v.details.user_timeline_media.map((user_timeline_media_v) => {
                                    let imagePath = regionalStorageURL + this.props.authData.centerData.center_uuid + '/user_timeline_media/' + user_timeline_media_v.utm_name;
                                    let $utm_folder = user_timeline_media_v['utm_folder'];
                                    if ($utm_folder != null) {
                                        if ($utm_folder == 'educorepublic' || $utm_folder == 'Educore-ObjectStorage') {
                                            imagePath = user_timeline_media_v['utm_url'];
                                        } else {
                                            imagePath = regionalStorageURL + this.props.authData.centerData.center_uuid + '/' + $utm_folder + '/' + user_timeline_media_v.utm_name;
                                        }
                                    }
                                    return <div className='mb-1'>
                                        <img src={imagePath} style={{ width: 106, objectFit: 'contain', }} />
                                    </div>
                                })}

                                {/* <div className='mb-1'>
                                    <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/user_timeline_media/' + assesslog_v.details.assesslog_pic1} style={{ width: 106, objectFit: 'contain', }} />
                                </div>
                                <div className='mb-1'>
                                    <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/user_timeline_media/' + assesslog_v.details.assesslog_pic2} style={{ width: 106, objectFit: 'contain', }} />
                                </div>
                                <div>
                                    <img src={regionalStorageURL + this.props.authData.centerData.center_uuid + '/user_timeline_media/' + assesslog_v.details.assesslog_pic3} style={{ width: 106, objectFit: 'contain', }} />
                                </div> */}
                            </div>
                        </div>

                    </div>
                    {/* FOOTER START */}
                    {this.renderFooter()}
                    {/* FOOTER END */}
                </div>
            })}


        </div >)
    }
}


const mapStateToProps = (state) => ({
    authData: state.auth.authData,
    defaultLanguage: state.language.defaultLanguage,
    selectedClass: state.selectedClass.data,
    children: state.children.list,
    defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(AssessmentDetailObservation);